<fieldset class="c-rating">
	<legend class="u-sr-only">{{ 'Common.Rating' | translate }}</legend>
	<ng-container *ngFor="let rating of vm.ratings ; let $index=index">
		<input class="c-rating__input u-sr-only" type="checkbox" name="{{vm.uid}}" id="{{vm.uid}}-{{vm.ratings?.length - $index}}" value="{{vm.ratings?.length - $index}}" [checked]="vm.model >= vm.ratings?.length - $index" (click)="onSelectionChange($event, vm.ratings?.length - $index)" [required]="vm.isRequired">
		<label class="c-rating__label c-rating__label--lg" for="{{vm.uid}}-{{vm.ratings?.length - $index}}" title="{{vm.ratings?.length - $index}}/{{vm.ratings?.length}}">
			<i class="o-icon o-icon--star" aria-hidden="true"></i>
			<span class="u-sr-only">{{vm.ratings?.length - $index}}/{{vm.ratings?.length}}</span>
		</label>
	</ng-container>
</fieldset>
